import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
} from "@fortawesome/free-solid-svg-icons";
const Pagination = (props) => {
  const {
    type,
    itemsCount,
    pageSize,
    currentPage,
    onPageChange,
    previousPage,
    nextPage,
    style,
  } = props;
  const pagesCount = Math.ceil(itemsCount / pageSize);
  // if (pagesCount === 1) return null;
  const pages = _.range(1, pagesCount + 1);
  // console.log(pages, currentPage);
  return (
    <nav
      style={{ marginBottom: "16px", ...style }}
      aria-label="Page navigation example"
    >
      {itemsCount === 0 ? null : (
        <ul style={{ margin: 0 }} className="pagination">
          {/* {currentPage > 9 && ( */}
          <li className={"page-item " + (currentPage === 1 ? "disabled" : "")}>
            <a
              className="page-link pageButton"
              aria-label="pagination-first"
              role="link"
              onClick={() => onPageChange(1)}
            >
              {type === "modern" ? (
                <FontAwesomeIcon icon={faAnglesLeft} />
              ) : (
                "First"
              )}
            </a>
          </li>
          {/* )} */}

          {itemsCount == 0 ? null : (
            <li
              className={"page-item " + (currentPage === 1 ? "disabled" : "")}
            >
              <a
                className="page-link pageButton"
                aria-label="pagination-prev"
                role="link"
                onClick={() => previousPage()}
              >
                {type === "modern" ? (
                  <FontAwesomeIcon icon={faAngleLeft} />
                ) : (
                  "Prev"
                )}
              </a>
            </li>
          )}

          {pages.map((page) => {
            if (
              page >= parseInt(currentPage - 4) &&
              page < parseInt(currentPage + 11)
            ) {
              return (
                <li
                  className={
                    "page-item " + (page === currentPage ? "active" : "")
                  }
                  key={page}
                >
                  <a
                    role="link"
                    className="page-link"
                    onClick={() => onPageChange(page)}
                    style={{ cursor: "pointer" }}
                  >
                    {page}
                  </a>
                </li>
              );
            }
          })}
          {itemsCount == 0 ? null : (
            <li
              className={
                "page-item " + (currentPage === pages.length ? "disabled" : "")
              }
            >
              <a
                className="page-link"
                role="link"
                aria-label="pagination-next"
                onClick={() => nextPage()}
              >
                {type === "modern" ? (
                  <FontAwesomeIcon icon={faAngleRight} />
                ) : (
                  "Next"
                )}
              </a>
            </li>
          )}

          {/* {currentPage < 9 && ( */}
          <li
            className={
              "page-item " +
              (currentPage === Math.ceil(itemsCount / pageSize)
                ? "disabled"
                : "")
            }
          >
            <a
              className="page-link pageButton"
              aria-label="pagination-last"
              role="link"
              onClick={() => onPageChange(Math.ceil(itemsCount / pageSize))}
            >
              {type === "modern" ? (
                <FontAwesomeIcon icon={faAnglesRight} />
              ) : (
                "Last"
              )}
            </a>
          </li>
          {/* )} */}
        </ul>
      )}
    </nav>
  );
};
Pagination.propTypes = {
  type: PropTypes.string,
  itemsCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};
export default Pagination;
